import { render } from "./KISWeb.vue?vue&type=template&id=6ed7ff1f"
import script from "./KISWeb.vue?vue&type=script&lang=js"
export * from "./KISWeb.vue?vue&type=script&lang=js"

import "./KISWeb.vue?vue&type=style&index=0&id=6ed7ff1f&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__